
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HealthIssueItem } from '@clients/bff';
import CarHealthIssueItems from '@components/car-health/CarHealthIssueItems.vue';
import CarHealthIssuesHeader from '@components/car-health/CarHealthIssuesHeader.vue';
import AppListItemPlaceholder from '@components/new-styleguide/AppListItemPlaceholder.vue';

@Component({
  name: 'CarHealthTabWarnings',
  components: {
    CarHealthIssueItems,
    CarHealthIssuesHeader,
    AppListItemPlaceholder
  }
})
export default class CarHealthTabWarnings extends Vue {
  @Prop({ default: false })
  private loading: boolean;

  @Prop({ required: true })
  private warnings: Array<HealthIssueItem>;

  @Prop({ required: true })
  private recommendations: Array<HealthIssueItem>;

  get warningsHeaderText() {
    return `${this.warnings.length} Warnung${this.warnings.length > 1 ? 'en' : ''}`
  }
  get recommendationsHeaderText() {
    return `${this.recommendations.length} Empfehlung${this.recommendations.length > 1 ? 'en' : ''}`
  }
}
